// Sets a canvas's bitmap size the way `canvas.width = w; canvas.height = h` does for what ends up drawn: a new
// size is set as before, but the same size is reset in place (cleared, the context's state back to its
// defaults) where the browser can (CanvasRenderingContext2D.reset). Setting the size reallocates the bitmap
// even when it doesn't change, which for the map's full-screen canvases (up to 5760×3600 on a retina screen)
// meant throwing the memory away and taking it again on every pan. Elsewhere it's set as before.
export const sizeCanvas = (canvas, ctx, width, height) => {
    if (canvas.width === width && canvas.height === height && ctx && typeof ctx.reset === 'function') {
        ctx.reset();
        return;
    }
    canvas.width = width;
    canvas.height = height;
};

export default sizeCanvas;
